import React, { useEffect, useState } from 'react';
import './newsTopicPage.scss';
import Card533Img from '../../components/contents/card533Img/Card533Img';
import MoreViewBTn from '../../components/buttons/moreView/MoreView';
import CustomSelect from '../../components/select/customSelect/CustomSelect';

import SubscribeBtn from '../../components/buttons/subscribe/SubscribeBtn';
import { axiosAuth } from '../../api/api';
import { ICategoryNews, IContent, INews } from '../../tpyes/comment';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

const NewsTopicPage = () => {
  const { id } = useParams<{ id: string }>();
  // const [categoryId, setCategoryId] = useState<string>();
  const [categories, setCategories] = useState<ICategoryNews[]>([]);
  const [contentList, setContentList] = useState<IContent[]>([]);
  const [more, setMore] = useState<string>('');
  const [search, setSearch] = useState<string>('');
  const [selectCategory, setSelectCategory] = useState<number>(0);
  const [showButton, setShowButton] = useState(false);
  const [responsive, setResponsive] = useState('');

  const navigate = useNavigate();
  const MAX_RETRIES = 3;

  const handleResize = () => {
    if (1300 < window.innerWidth) {
      setResponsive('desktop');
    } else if (768 < window.innerWidth && window.innerWidth <= 1300) {
      setResponsive('tablet');
    } else {
      setResponsive('mobile');
    }
  };
  useEffect(() => {
    getCategories();
    getContentList();
    window.scrollTo({ top: 0, behavior: 'smooth' });

    if (1300 < window.innerWidth) {
      setResponsive('desktop');
    } else if (768 < window.innerWidth && window.innerWidth <= 1300) {
      setResponsive('tablet');
    } else if (390 <= window.innerWidth) {
      setResponsive('mobile');
    }

    const handleScroll = () => {
      setShowButton(window.pageYOffset > 1000);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [id]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const seachHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const getCategories = async () => {
    try {
      const response = await axiosAuth?.get('/news/api/news-category/');
      const dataList = response.data;
      const newCategories = dataList.map((item: INews) => item?.latest_news?.category);
      newCategories.unshift({ id: '', name: 'ALL', order: 0, main_image: '' });
      setCategories(newCategories);
    } catch (error) {
      console.log(error);
    }
  };

  const getContentList = async () => {
    let retries = 0;
    const url = id
      ? `/news/api/news/?category=${id}&limit=6&ordering=-published_at&is_published=true`
      : '/news/api/news/?category=&limit=6&ordering=-published_at&is_published=true';
    while (retries < MAX_RETRIES) {
      try {
        const response = await axiosAuth?.get(url);
        const { results, next } = response.data;
        if (next === null || next === undefined || next === '') {
          setMore('');
        } else {
          const pathAndQuery = next.split('site')[1];
          setMore(pathAndQuery);
        }

        setContentList(results);

        return results;
      } catch (error) {
        retries++;
        if (retries === MAX_RETRIES) {
          Swal.fire('Please try again later.');
          navigate('/');
        }
      }
    }
  };

  const addContentList = async () => {
    try {
      const response = await axiosAuth?.get(more);
      const { results, next, count } = response.data;
      if (count === contentList.length) {
        return Swal.fire('There are no more articles.');
      }
      if (!next) {
        setContentList([...contentList, ...results]);
      } else {
        const pathAndQuery = next.split('site')[1];
        setContentList([...contentList, ...results]);
        setMore(pathAndQuery);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getSearchList = async (category: number, search: string) => {
    if (!search) {
      Swal.fire('Please enter a search word.');
      return;
    }
    try {
      const response = await axiosAuth?.get(`/news/api/news/?category=${category}&search=${search}&ordering=-published&limit=6&is_publishedt=true`);
      const { results, next } = response.data;

      setContentList(results);
      if (next === null) {
        setMore('');
      } else {
        const pathAndQuery = next.split('site')[1];
        setMore(pathAndQuery);
      }
      setSearch('');
    } catch (error) {
      console.log(error);
    }
    setSearch('');
  };

  function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      getSearchList(selectCategory, search);
      setSearch('');
    }
  }

  return (
    <div className="page-newsTopic">
      {showButton && responsive === 'mobile' && (
        <img src="/seamansclub-news/assets/svg/scroll_top.svg" alt="" className="top-btn" onClick={scrollToTop} />
      )}
      <div className="container flex fd-col">
        <div className="flex jc-end">
          <CustomSelect cateGoryList={categories} setCategory={setSelectCategory as (id: number | '') => void} />
          <input type="text" name="" id="search" placeholder="SEARCH FOR A TOPIC" onChange={seachHandler} value={search} onKeyDown={handleKeyDown} />
          <div className="icon_box flex ai-center" onClick={() => getSearchList(selectCategory, search)}>
            <img src="/seamansclub-news/assets/svg/search-icon.svg" alt="search icon" className="search_icon" width={20} />
          </div>
        </div>

        <div className="content-container flex jc-between">
          {contentList.map((item: IContent, index: number) => {
            return (
              <React.Fragment key={index}>
                <Card533Img
                  title={item.title}
                  subtitle={item.subtitle}
                  image={item.image}
                  category={item.category}
                  published_at={item.published_at || ''}
                  updated_at={item.updated_at}
                  id={+item?.id ? +item.id : 0}
                  isMobile={responsive}
                />
              </React.Fragment>
            );
          })}
        </div>
        <div className="more-box flex jc-center" onClick={() => addContentList()}>
          <MoreViewBTn />
        </div>

        <SubscribeBtn />
      </div>
    </div>
  );
};

export default NewsTopicPage;
